__turbopack_context__.v({
  "annotations-emerge": "object-viewer-module__mHs0xW__annotations-emerge",
  "cacheDialog": "object-viewer-module__mHs0xW__cacheDialog",
  "cachedModel": "object-viewer-module__mHs0xW__cachedModel",
  "cardLoading": "object-viewer-module__mHs0xW__cardLoading",
  "cover": "object-viewer-module__mHs0xW__cover",
  "dialog": "object-viewer-module__mHs0xW__dialog",
  "model": "object-viewer-module__mHs0xW__model",
  "object-emerge": "object-viewer-module__mHs0xW__object-emerge",
  "returningCard": "object-viewer-module__mHs0xW__returningCard",
  "stage": "object-viewer-module__mHs0xW__stage",
  "status": "object-viewer-module__mHs0xW__status",
  "trigger": "object-viewer-module__mHs0xW__trigger",
});
